import React, { useContext, useEffect, useRef, useState } from "react";
import ConfidentialPopup from "../confidentialpopup";
import showMessage from "../../../../../common/message";
import {
  BOTAPIError,
  InternalAPIError,
} from "../../../../../../utils/apiErrors";
import { handleApiError } from "../../../../../../utils/globalErrorHandler";
import {
  handlePIIChange,
  getHighlightedText,
  textContainsPIIText,
} from "../../../../../../services/piiService";
import { getUseSkills } from "../../../services/promptManagementService";
import { splitPromptsAndTags } from "../../../shared/promptConverter";
import PromptResults from "../promptResults";
import GeneratedPrompts from "../generatedPrompts";
import loaderContext from "../../../../../../context/loader/loaderContext";
import { promptAPIURI } from "../../../../../../constants/enums.js";

const PromptStepTwo = ({
  moveToLastStep,
  onBackStep,
  promptTextData,
  stepOneData,
  chatbotResponse,
  setChatbotResponse,
  handleAppendTags,
  promptMessage,
  setPromptMessage,
  backButtonClicked,
  handleBackButtonClicked,
  prevPromptMessage,
  setPromptFormChild,
  mksDefaultConfiguration,
  selectedPromptForTest,
  setSelectedPromptForTest,
  setIsShowConfidentialPopup,
  isShowConfidentialPopup,
}) => {
  const [showTab, setShowTab] = useState(1);
  const [useSkills, setUseSkills] = useState([]);
  const promptText1ref = useRef("");
  const promptText2ref = useRef("");
  const promptText3ref = useRef("");
  const [promptForm, setPromptForm] = useState(promptTextData);
  const { updateLoaderStatus } = useContext(loaderContext);
  const [isPromptVisible, setIsPromptVisible] = useState(false);
  const [selectedChatbot, setSelectedChatbot] = useState();
  const [loadHighlightedText, setLoadHighlightedText] = useState(false);

  useEffect(() => {
    getUseSkillsData();
    if (!backButtonClicked) {
      rebindDefaultData();
    } else {
      handleBackButtonClicked();
      setIsPromptVisible(true);
      setPromptMessage(prevPromptMessage);
      updateLoaderStatus(false);
    }
  }, []);

  const bindSkillDetails = () => {
    getUseSkills().then((resp) => {
      const selectedSkill = resp?.filter(
        (item) => item.Id === parseInt(promptForm.SkillStoreId)
      )[0];

      setSelectedChatbot(selectedSkill);
    });
  };

  useEffect(() => {
    if (promptTextData !== null) {
      setPromptForm(promptTextData);
      setLoadHighlightedText(true);
    }
  }, [promptTextData]);

  useEffect(() => {
    highlightText();
  }, [loadHighlightedText]);

  const highlightText = () => {
    if (promptForm?.PromptBackground !== undefined) {
      promptText1ref.current.innerHTML = getHighlightedText(
        promptForm?.PromptBackground
      );
    }
    if (promptForm?.DesiredPromptOutput !== undefined) {
      promptText2ref.current.innerHTML = getHighlightedText(
        promptForm?.DesiredPromptOutput
      );
    }
    if (promptForm?.SourceOnInputOutput) {
      promptText3ref.current.innerHTML = getHighlightedText(
        promptForm?.SourceOnInputOutput
      );
    }
  };

  const getUseSkillsData = () => {
    getUseSkills().then((resp) => {
      setUseSkills(resp);
    });
  };

  const rebindDefaultData = () => {
    const isNewFlag = process.env.REACT_APP_PROMPT_FLAG_MKS_NEW;
    if (isNewFlag === "true") {
      handleRegeneratePromptOnPageLoadWrapper();
    } else {
      handleRegeneratePromptOnPageLoad();
    }
  };

  const handleRegeneratePromptOnPageLoad = async () => {
    try {
      updateLoaderStatus(true);
      setSelectedPromptForTest("");
      const prompt1 =
        promptTextData?.PromptBackground === undefined
          ? ""
          : promptTextData?.PromptBackground;
      const prompt2 =
        promptTextData?.DesiredPromptOutput === undefined
          ? ""
          : promptTextData?.DesiredPromptOutput;
      let compbinedPrompt = prompt1 + " " + prompt2;
      let compbinedPromptText = process.env.REACT_APP_WRITE_FOUR_PROMPT_TEXT;
      let finalPrompt = compbinedPromptText
        .replace("{prompttext}", compbinedPrompt)
        .replace("{textLength}", promptTextData?.inputWordCount)
        .replace("{preference}", promptTextData?.SelectedPreference);

      let response = "";
      let stringBody = mksDefaultConfiguration?.body;
      let userMessage = mksDefaultConfiguration?.userMessage;
      let message1 = userMessage?.replace("$Message", `"$"`);

      let parseMessage1 = JSON.parse(message1);
      parseMessage1.content[0].text = finalPrompt;

      let requestBody = stringBody?.replace(",$UserMessage", "");
      let convertedJson = JSON.parse(requestBody);
      convertedJson.messages.push(parseMessage1);

      convertedJson.messages.map((item) => {
        if (item.role === "user") {
          item.content[0].text = finalPrompt;
        } else if (item.role === "system") {
          item.content[0].text =
            "Given a task description or existing prompt, produce a detailed system prompt to guide a language model in completing the task effectively.# Guidelines - Understand the Task: Grasp the main objective, goals, requirements, constraints, and expected output.- Minimal Changes: If an existing prompt is provided, improve it only if it s simple. For complex prompts, enhance clarity and add missing elements without altering the original structure.- Reasoning Before Conclusions**: Encourage reasoning steps before any conclusions are reached. ATTENTION! If the user provides examples where the reasoning happens afterward, REVERSE the order! NEVER START EXAMPLES WITH CONCLUSIONS!- Reasoning Order: Call out reasoning portions of the prompt and conclusion parts (specific fields by name). For each, determine the ORDER in which this is done, and whether it needs to be reversed.- Conclusion, classifications, or results should ALWAYS appear last.- Examples: Include high-quality examples if helpful, using placeholders [in brackets] for complex elements.- What kinds of examples may need to be included, how many, and whether they are complex enough to benefit from placeholders.- Clarity and Conciseness: Use clear, specific language. Avoid unnecessary instructions or bland statements.- Formatting: Use markdown features for readability. DO NOT USE CODE BLOCKS UNLESS SPECIFICALLY REQUESTED.- Preserve User Content: If the input task or prompt includes extensive guidelines or examples, preserve them entirely, or as closely as possible. If they are vague, consider breaking down into sub-steps. Keep any details, guidelines, examples, variables, or placeholders provided by the user.- Constants: DO include constants in the prompt, as they are not susceptible to prompt injection. Such as guides, rubrics, and examples.- Output Format: Explicitly the most appropriate output format, in detail. This should include length and syntax (e.g. short sentence, paragraph, JSON, etc.)- For tasks outputting well-defined or structured data (classification, JSON, etc.) bias toward outputting a JSON.- JSON should never be wrapped in code blocks () unless explicitly requested.The final prompt you output should adhere to the following structure below. Do not include any additional commentary, only output the completed system prompt. SPECIFICALLY, do not include any additional messages at the start or end of the prompt. (e.g. no [Concise instruction describing the task - this should be the first line in the prompt, no section header][Additional details as needed.][Optional sections with headings or bullet points for detailed steps.]# Steps [optional][optional: a detailed breakdown of the steps necessary to accomplish the task]# Output Format[Specifically call out how the output should be formatted, be it response length, structure e.g. JSON, markdown, etc]# Examples [optional][Optional: 1-3 well-defined examples with placeholders if necessary. Clearly mark where examples start and end, and what the input and output are. User placeholders as necessary.][If the examples are shorter than what a realistic example is expected to be, make a reference with () explaining how real examples should be longer / shorter / different. AND USE PLACEHOLDERS! ]# Notes [optional][optional: edge cases, details, and an area to call or repeat out specific important considerations]";
        }
        return item;
      });

      try {
        const responseA = await fetch(
          removeTrailingSlash(mksDefaultConfiguration.url),
          {
            method: mksDefaultConfiguration.method,
            headers: mksDefaultConfiguration.headers,
            body: JSON.stringify(convertedJson),
          }
        );

        if (!responseA.ok || !responseA.body) {
          handleApiError(new BOTAPIError());
          return;
        }
        const reader = responseA.body.getReader();
        const decoder = new TextDecoder();
        const loopRunner = true;

        while (loopRunner) {
          try {
            const { value, done } = await reader.read();
            if (done) {
              break;
            }
            const decodedChunk = decoder.decode(value, { stream: true });
            let datas;

            try {
              // Process the decoded chunk
              datas = JSON.parse(
                JSON.stringify(
                  decodedChunk
                    .replace("data: ", "")
                    .split("\n\ndata:")
                    .slice(0, -1)
                )
              );
            } catch (decodeError) {
              console.log("Error processing decoded chunk:", decodeError);
              continue; // Skip this chunk if JSON parsing fails
            }

            // Process each item in the parsed data
            let counter = 0;
            datas.forEach((da) => {
              let jsonArray = null;
              try {
                jsonArray = JSON.parse(da);
                if (jsonArray.choices.length > 0) {
                  const text = jsonArray.choices[0].delta?.content || "";
                  if (counter < 2 && (text.match(/\n/) || []).length) {
                    return;
                  }
                  response = response + text;
                  counter++;
                }
              } catch (parseError) {
                console.log(
                  "Error parsing JSON array item:",
                  parseError,
                  " Raw Item ",
                  da
                );
              }
            });
          } catch (readError) {
            break; // Exit the loop if reading fails
          }
        }
      } catch (fetchError) {
        handleApiError(new BOTAPIError());
        // Handle fetch error, such as displaying a message to the user
      }

      try {
        const data = splitPromptsAndTags(response);
        let promptsArray = data.map((item) => {
          return {
            ModelAPIURL: "",
            PromptStyle: "",
            WordCount: 0,
            PromptGenerated: false,
            promptMessage: item.prompt,
            Status: "",
            Id: 0,
            tags: item.tags,
            isSelected: false,
          };
        });
        setPromptMessage([...promptsArray]);
        updateLoaderStatus(false);
        setIsPromptVisible(true);
      } catch (error) {
        let newPrompts = [];
        newPrompts.push({
          promptMessage: JSON.stringify(response),
          promptId: 1,
        });
        setPromptMessage((existingPrompt) => {
          return [...newPrompts];
        });
        updateLoaderStatus(false);
        setIsPromptVisible(true);
      }

      if (selectedChatbot === undefined) {
        bindSkillDetails();
      }
    } catch (ex) {
      updateLoaderStatus(false);
      handleApiError(new InternalAPIError());
    }
  };

  const handleRegeneratePromptOnPageLoadWrapper = async () => {
    try {
      updateLoaderStatus(true);
      setSelectedPromptForTest("");

      let finalPrompt =
        promptTextData?.PromptBackground === undefined
          ? ""
          : promptTextData?.PromptBackground;

      
      let userMessageModel = {
        user_messages: finalPrompt,
        word_count: promptTextData?.inputWordCount,
        mode: promptTextData?.SelectedPreference,
      };

      let response = "";

      try {
       
        const apiURL = process.env.REACT_APP_PROMPT_WRAPPER_URL + promptAPIURI;
        const apiResponse = await fetch(apiURL, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userMessageModel),
        });

        
        const data = await apiResponse.text();
        let replacedChunk = JSON.parse(data);
        if (replacedChunk.choices.length > 0) {
          replacedChunk.choices[0].messages.forEach((msg) => {
            if (msg?.role === "tool") {
            } else if (msg?.role === "assistant") {
              response = response + msg?.content;
            }
          });
        }
      } catch (fetchError) {
        updateLoaderStatus(false);
        handleApiError(new BOTAPIError());
      }

      try {
        const data = splitPromptsAndTags(response);
        let promptsArray = data.map((item) => {
          return {
            ModelAPIURL: "",
            PromptStyle: "",
            WordCount: 0,
            PromptGenerated: false,
            promptMessage: item.prompt,
            Status: "",
            Id: 0,
            tags: item.tags,
            isSelected: false,
          };
        });
        setPromptMessage([...promptsArray]);
        updateLoaderStatus(false);
        setIsPromptVisible(true);
      } catch (error) {
        let newPrompts = [];
        newPrompts.push({
          promptMessage: JSON.stringify(response),
          promptId: 1,
        });
        setPromptMessage((existingPrompt) => {
          return [...newPrompts];
        });
        updateLoaderStatus(false);
        setIsPromptVisible(true);
      }

      if (selectedChatbot === undefined) {
        bindSkillDetails();
      }
    } catch (ex) {
      updateLoaderStatus(false);
      handleApiError(new InternalAPIError());
    }
  };

  const handleRegeneratePromptResultWrapper = async () => {
    try {
      setIsPromptVisible(true);
      setSelectedPromptForTest("");
      if (
        promptForm.PromptBackground === "" ||
        promptForm.PromptBackground === null ||
        promptForm.PromptBackground === undefined
      ) {
        showMessage("Please provide background for Prompt.", -2);
        promptText1ref.current.classList.add("border-red");
        promptText1ref.current.focus();
      } else if (
        promptForm.DesiredPromptOutput === "" ||
        promptForm.DesiredPromptOutput === null ||
        promptForm.DesiredPromptOutput === undefined
      ) {
        showMessage("Please provide desired output format for Prompt.", -2);
        promptText2ref.current.classList.add("border-red");
        promptText2ref.current.focus();
      } else {
        updateLoaderStatus(true);
        let finalPrompt = promptForm?.PromptBackground;
        let response = "";
        

        let userMessageModel = {
          user_messages: finalPrompt,
          word_count: promptTextData?.inputWordCount,
          mode: promptTextData?.SelectedPreference,
        };
        try {
        
          const apiURL =
            process.env.REACT_APP_PROMPT_WRAPPER_URL + promptAPIURI;
          const apiResponse = await fetch(apiURL, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
              "Content-Type": "application/json",
            },
            body: JSON.stringify(userMessageModel),
          });

          const data = await apiResponse.text();
          let replacedChunk = JSON.parse(data);
          if (replacedChunk.choices.length > 0) {
            replacedChunk.choices[0].messages.forEach((msg) => {
              if (msg?.role === "tool") {
              } else if (msg?.role === "assistant") {
                response = response + msg?.content;
              }
            });
          }
        } catch (fetchError) {
          updateLoaderStatus(false);
          handleApiError(new BOTAPIError());
        }
        try {
          const data = splitPromptsAndTags(response);
          let promptsArray = data.map((item) => {
            return {
              ModelAPIURL: "",
              PromptStyle: "",
              WordCount: 0,
              PromptGenerated: false,
              promptMessage: item.prompt,
              Status: "",
              Id: 0,
              tags: item.tags,
              isSelected: false,
            };
          });
          setPromptMessage([...promptsArray]);
          updateLoaderStatus(false);
          setIsPromptVisible(true);
        } catch (error) {
          let newPrompts = [];
          newPrompts.push({
            promptMessage: JSON.stringify(response),
            promptId: 1,
          });
          setPromptMessage((existingPrompt) => {
            return [...newPrompts];
          });
          updateLoaderStatus(false);
          setIsPromptVisible(true);
        }
      }
    } catch (ex) {
      updateLoaderStatus(false);
      setIsPromptVisible(true);
      handleApiError(new InternalAPIError());
    }
  };

  const handleRegeneratePromptResult = async () => {
    try {
      setIsPromptVisible(true);
      setSelectedPromptForTest("");
      if (
        promptForm.PromptBackground === "" ||
        promptForm.PromptBackground === null ||
        promptForm.PromptBackground === undefined
      ) {
        showMessage("Please provide background for Prompt.", -2);
        promptText1ref.current.classList.add("border-red");
        promptText1ref.current.focus();
      } else if (
        promptForm.DesiredPromptOutput === "" ||
        promptForm.DesiredPromptOutput === null ||
        promptForm.DesiredPromptOutput === undefined
      ) {
        showMessage("Please provide desired output format for Prompt.", -2);
        promptText2ref.current.classList.add("border-red");
        promptText2ref.current.focus();
      } else if (
        promptForm.SourceOnInputOutput === "" ||
        promptForm.SourceOnInputOutput === null ||
        promptForm.SourceOnInputOutput === undefined
      ) {
        showMessage("Please provide source/input for Prompt.", -2);
        promptText3ref.current.classList.add("border-red");
        promptText3ref.current.focus();
      } else {
        updateLoaderStatus(true);
        let compbinedPromptText = process.env.REACT_APP_WRITE_FOUR_PROMPT_TEXT;
        let compbinedPrompt =
          promptForm?.PromptBackground +
          " " +
          promptForm?.DesiredPromptOutput +
          " " +
          promptForm?.SourceOnInputOutput;
        let finalPrompt = compbinedPromptText
          .replace("{prompttext}", compbinedPrompt)
          .replace("{textLength}", promptForm?.inputWordCount)
          .replace("{preference}", promptTextData?.SelectedPreference);
        let response = "";
        let stringBody = mksDefaultConfiguration?.body;
        let userMessage = mksDefaultConfiguration?.userMessage;

        let message1 = userMessage?.replace("$Message", `"$"`);

        let parseMessage1 = JSON.parse(message1);
        parseMessage1.content[0].text = finalPrompt;

        let requestBody = stringBody.replace(",$UserMessage", "");
        let convertedJson = JSON.parse(requestBody);
        convertedJson.messages.push(parseMessage1);

        convertedJson.messages.map((item) => {
          if (item.role === "user") {
            item.content[0].text = finalPrompt;
          } else if (item.role === "system") {
            item.content[0].text =
              "Given a task description or existing prompt, produce a detailed system prompt to guide a language model in completing the task effectively.# Guidelines - Understand the Task: Grasp the main objective, goals, requirements, constraints, and expected output.- Minimal Changes: If an existing prompt is provided, improve it only if it s simple. For complex prompts, enhance clarity and add missing elements without altering the original structure.- Reasoning Before Conclusions**: Encourage reasoning steps before any conclusions are reached. ATTENTION! If the user provides examples where the reasoning happens afterward, REVERSE the order! NEVER START EXAMPLES WITH CONCLUSIONS!- Reasoning Order: Call out reasoning portions of the prompt and conclusion parts (specific fields by name). For each, determine the ORDER in which this is done, and whether it needs to be reversed.- Conclusion, classifications, or results should ALWAYS appear last.- Examples: Include high-quality examples if helpful, using placeholders [in brackets] for complex elements.- What kinds of examples may need to be included, how many, and whether they are complex enough to benefit from placeholders.- Clarity and Conciseness: Use clear, specific language. Avoid unnecessary instructions or bland statements.- Formatting: Use markdown features for readability. DO NOT USE CODE BLOCKS UNLESS SPECIFICALLY REQUESTED.- Preserve User Content: If the input task or prompt includes extensive guidelines or examples, preserve them entirely, or as closely as possible. If they are vague, consider breaking down into sub-steps. Keep any details, guidelines, examples, variables, or placeholders provided by the user.- Constants: DO include constants in the prompt, as they are not susceptible to prompt injection. Such as guides, rubrics, and examples.- Output Format: Explicitly the most appropriate output format, in detail. This should include length and syntax (e.g. short sentence, paragraph, JSON, etc.)- For tasks outputting well-defined or structured data (classification, JSON, etc.) bias toward outputting a JSON.- JSON should never be wrapped in code blocks () unless explicitly requested.The final prompt you output should adhere to the following structure below. Do not include any additional commentary, only output the completed system prompt. SPECIFICALLY, do not include any additional messages at the start or end of the prompt. (e.g. no [Concise instruction describing the task - this should be the first line in the prompt, no section header][Additional details as needed.][Optional sections with headings or bullet points for detailed steps.]# Steps [optional][optional: a detailed breakdown of the steps necessary to accomplish the task]# Output Format[Specifically call out how the output should be formatted, be it response length, structure e.g. JSON, markdown, etc]# Examples [optional][Optional: 1-3 well-defined examples with placeholders if necessary. Clearly mark where examples start and end, and what the input and output are. User placeholders as necessary.][If the examples are shorter than what a realistic example is expected to be, make a reference with () explaining how real examples should be longer / shorter / different. AND USE PLACEHOLDERS! ]# Notes [optional][optional: edge cases, details, and an area to call or repeat out specific important considerations]";
          }
          return item;
        });

        try {
          const responseA = await fetch(
            removeTrailingSlash(mksDefaultConfiguration.url),
            {
              method: mksDefaultConfiguration.method,
              headers: mksDefaultConfiguration.headers,
              body: JSON.stringify(convertedJson),
            }
          );

          if (!responseA.ok || !responseA.body) {
            handleApiError(new BOTAPIError());
            return;
          }
          const reader = responseA.body.getReader();
          const decoder = new TextDecoder();
          const loopRunner = true;

          while (loopRunner) {
            try {
              const { value, done } = await reader.read();
              if (done) {
                break;
              }
              const decodedChunk = decoder.decode(value, { stream: true });
              let datas;

              try {
                // Process the decoded chunk
                datas = JSON.parse(
                  JSON.stringify(
                    decodedChunk
                      .replace("data: ", "")
                      .split("\n\ndata:")
                      .slice(0, -1)
                  )
                );
              } catch (decodeError) {
                console.log("Error processing decoded chunk:", decodeError);

                continue;
              }

              let counter = 0;
              datas.forEach((da) => {
                let jsonArray = null;
                try {
                  jsonArray = JSON.parse(da);
                  if (jsonArray.choices.length > 0) {
                    const text = jsonArray.choices[0].delta?.content || "";
                    if (counter < 2 && (text.match(/\n/) || []).length) {
                      return;
                    }
                    response = response + text;
                    counter++;
                  }
                } catch (parseError) {
                  console.log(
                    "Error parsing JSON array item:",
                    parseError,
                    " Raw Item ",
                    da
                  );
                }
              });
            } catch (readError) {
              break; // Exit the loop if reading fails
            }
          }
        } catch (fetchError) {
          handleApiError(new BOTAPIError());
        }

        try {
          const data = splitPromptsAndTags(response);
          let promptsArray = data.map((item) => {
            return {
              ModelAPIURL: "",
              PromptStyle: "",
              WordCount: 0,
              PromptGenerated: false,
              promptMessage: item.prompt,
              Status: "",
              Id: 0,
              tags: item.tags,
              isSelected: false,
            };
          });
          setPromptMessage([...promptsArray]);
          updateLoaderStatus(false);
          setIsPromptVisible(true);
        } catch (error) {
          let newPrompts = [];
          newPrompts.push({
            promptMessage: JSON.stringify(response),
            promptId: 1,
          });
          setPromptMessage((existingPrompt) => {
            return [...newPrompts];
          });
          updateLoaderStatus(false);
          setIsPromptVisible(true);
        }
      }
    } catch (ex) {
      updateLoaderStatus(false);
      setIsPromptVisible(true);
      handleApiError(new InternalAPIError());
    }
  };

  const handleRegenerateClick = () => {
    const isNewFlag = process.env.REACT_APP_PROMPT_FLAG_MKS_NEW;
    if (isNewFlag === "true") {
      handleRegeneratePromptResultWrapper();
    } else {
      handleRegeneratePromptResult();
    }
  };

  const handleConfidentialChecked = (value) => {
    setIsShowConfidentialPopup(false);
    if (value) {
      setPromptForm((prevData) => ({
        ...prevData,
        isConfidential: value,
      }));

      moveToLastStep(promptForm);
    }
  };

  const handlePromptSelected = (e, item) => {
    let pm = promptMessage;
    pm.map((p) => {
      if (p.promptMessage === item.promptMessage) {
        p.isSelected = e.currentTarget.checked;
      } else {
        p.isSelected = false;
      }
      return p;
    });

    setSelectedPromptForTest(item.promptMessage);
    if (e.currentTarget.checked) {
      const data = {
        ModelAPIURL: "",
        PromptStyle: "",
        WordCount: 0,
        PromptGenerated: true,
        PromptText: item.promptMessage,
        Id: 0,
        Status: "",
      };
      let selectedPrompt = [];
      selectedPrompt.push(data);
      setPromptForm((prevData) => ({
        ...prevData,
        PromptSystemGeneratedInputs: selectedPrompt,
        tags: item.tags,
      }));
      setPromptFormChild((prevData) => ({
        ...prevData,
        PromptSystemGeneratedInputs: selectedPrompt,
        tags: item.tags,
      }));
    }
    setPromptMessage(pm);

    if (item.tags !== undefined && item.tags.length > 0)
      handleAppendTags(item.tags);
  };

  const removeTrailingSlash = (url) => {
    return url.endsWith("\\") ? url.slice(0, -1) : url;
  };

  return (
    <>
      <div className="dash-section p20 prompt-step-two">
        <div className="prompt-explanaion">
          <div className="prompt-box">
            <p className="prompt-title-small">
              Provide some background and explain the use case for which you
              would like to design the prompt<span className="red">*</span>
            </p>
            <div
              contentEditable
              suppressContentEditableWarning
              ref={promptText1ref}
              className="prompt-textarea prompt-pii"
              value={promptForm?.PromptBackground.trim}
              onInput={(e) => {
                const textValue = e.currentTarget.innerText.trim();
                setPromptForm((prevData) => ({
                  ...prevData,
                  PromptBackground: textValue,
                }));
                setPromptFormChild((prevData) => ({
                  ...prevData,
                  PromptBackground: textValue,
                }));
                promptText1ref.current.classList.remove("border-red");
                if (textValue.length > 1000) {
                  // Truncate to 1000 characters
                  e.currentTarget.innerText = textValue.slice(0, 1000);

                  // Move cursor to the end
                  const range = document.createRange();
                  const sel = window.getSelection();
                  range.selectNodeContents(e.currentTarget);
                  range.collapse(false);
                  sel.removeAllRanges();
                  sel.addRange(range);
                }
                e.preventDefault();
              }}
              onBlur={(e) => handlePIIChange(e)}
              rows="5"
            ></div>
          </div>
          <div className="prompt-box">
            <p className="prompt-title-small">
              Articulate the desired output format in which you would like to
              see the response?<span className="red">*</span>
            </p>
            <div
              contentEditable
              suppressContentEditableWarning
              ref={promptText2ref}
              value={stepOneData?.DesiredPromptOutput.trim}
              onInput={(e) => {
                const textValue = e.currentTarget.innerText.trim();
                setPromptForm((prevData) => ({
                  ...prevData,
                  DesiredPromptOutput: textValue,
                }));
                setPromptFormChild((prevData) => ({
                  ...prevData,
                  DesiredPromptOutput: textValue,
                }));
                promptText2ref.current.classList.remove("border-red");
                if (textValue.length > 1000) {
                  // Truncate to 1000 characters
                  e.currentTarget.innerText = textValue.slice(0, 1000);

                  // Move cursor to the end
                  const range = document.createRange();
                  const sel = window.getSelection();
                  range.selectNodeContents(e.currentTarget);
                  range.collapse(false);
                  sel.removeAllRanges();
                  sel.addRange(range);
                }
                e.preventDefault();
              }}
              onBlur={(e) => handlePIIChange(e)}
              className="prompt-textarea prompt-pii"
              rows="5"
            ></div>
          </div>
          <div className="prompt-box">
            <p className="prompt-title-small">
              Tell us something more about the source/input data?
            </p>
            <div
              contentEditable
              suppressContentEditableWarning
              ref={promptText3ref}
              value={stepOneData?.SourceOnInputOutput.trim()}
              onInput={(e) => {
                const textValue = e.currentTarget.innerText.trim();
                setPromptForm((prevData) => ({
                  ...prevData,
                  SourceOnInputOutput: textValue,
                }));
                setPromptFormChild((prevData) => ({
                  ...prevData,
                  SourceOnInputOutput: textValue,
                }));
                promptText3ref.current.classList.remove("border-red");
                if (textValue.length > 1000) {
                  // Truncate to 1000 characters
                  e.currentTarget.innerText = textValue.slice(0, 1000);

                  // Move cursor to the end
                  const range = document.createRange();
                  const sel = window.getSelection();
                  range.selectNodeContents(e.currentTarget);
                  range.collapse(false);
                  sel.removeAllRanges();
                  sel.addRange(range);
                }
                e.preventDefault();
              }}
              onBlur={(e) => handlePIIChange(e)}
              className="prompt-textarea prompt-pii"
              rows="5"
            ></div>
          </div>
        </div>
        <div className="prompt-button-wrapper flex-end">
          <button
            onClick={() => handleRegenerateClick()}
            className="genrate-btn"
          >
            Regenerate All
          </button>
        </div>
      </div>
      <GeneratedPrompts
        isPromptVisible={isPromptVisible}
        promptMessage={promptMessage}
        handlePromptSelected={handlePromptSelected}
        onBackStep={onBackStep}
        promptFromChild={promptForm}
        useSkills={useSkills}
        setPromptForm={setPromptForm}
        setIsShowConfidentialPopup={setIsShowConfidentialPopup}
        setChatbotResponse={setChatbotResponse}
        hideBackButton={false}
        setPromptFormChild={setPromptFormChild}
        mksDefaultConfiguration={mksDefaultConfiguration}
        selectedPromptForTest={selectedPromptForTest}
        setSelectedPromptForTest={setSelectedPromptForTest}
      />
      {chatbotResponse.description !== "" &&
        chatbotResponse.description !== null &&
        chatbotResponse.description !== undefined && (
          <PromptResults
            showTab={showTab}
            setShowTab={setShowTab}
            chatbotResponse={chatbotResponse}
            promptStepOneDataOriginal={promptForm}
          />
        )}
      {isShowConfidentialPopup && (
        <ConfidentialPopup
          handleConfidentialChecked={handleConfidentialChecked}
        ></ConfidentialPopup>
      )}
    </>
  );
};

export default PromptStepTwo;
